import { createAction, props } from '@ngrx/store';
import {
  ActiveAlarmCounterDto,
  AgGridColumnSort,
  GroupedAlarmDto, AlarmDto, AgGridResponseOfGroupedAlarmDto, PagedAlarmDto, VehicleAlarmDto,
} from '@services/api/api.service';
import { Sort } from '@angular/material/sort';

export const setActiveAlarmSummary = createAction(
  'setActiveAlarmSummary',
  props<{
    value: ActiveAlarmCounterDto
  }>(),
);

export const setActiveAlarmLoading = createAction(
  'setActiveAlarmLoading',
  props<{ value: boolean }>(),
);
export const setActiveAlarmFilters = createAction(
  'setActiveAlarmFilters',
  props<{ filters: any }>(),
);
export const getActiveAlarmList = createAction(
  'getActiveAlarmList',
  props<{
    pageIndex: number;
    pageSize: number;
    sort?: Sort;
  }>(),
);

export const getActiveAlarmSummary = createAction(
  'getActiveAlarmSummary',
);

export const setActiveAlarmList = createAction(
  'setActiveAlarmList',
  props<{
    vehicles: GroupedAlarmDto[],
    page: number,
    pageSize: number,
    totalNumber: number
  }>(),
);

export const setAlarmsLoading = createAction(
  'setAlarmsLoading',
  props<{ isLoading: boolean }>(),
);

export const setAlarmsFilters = createAction(
  'setAlarmsFilters',
  props<{ filters: { qSearch?: string, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setAlarmsPaginator = createAction(
  'setAlarmsPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setAlarmsList = createAction(
  'setAlarmsList',
  props<{ response: PagedAlarmDto }>(),
);

export const getAlarmsList = createAction(
  'getAlarmsList',
);

export const setSelectedAlarmLoading = createAction(
  'setSelectedAlarmLoading',
  props<{ isLoading: boolean }>(),
);

export const setSelectedAlarmFilters = createAction(
  'setSelectedAlarmFilters',
  props<{ filters: { qSearch?: string, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setSelectedAlarmPaginator = createAction(
  'setSelectedAlarmPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setSelectedAlarmList = createAction(
  'setSelectedAlarmList',
  props<{ response: VehicleAlarmDto[] }>(),
);

export const getSelectedAlarmList = createAction(
  'getSelectedAlarmList',
  props<{ vin: string }>(),
);

export const setAlarmsCounters = createAction(
  'setAlarmsCounters',
  props<{
    counters: ActiveAlarmCounterDto
  }>(),
);

export const getAlarmsCounters = createAction(
  'getAlarmsCounters',
);
